import css from 'styled-jsx/css';

export default css`.clamplines {
  display: flex;
  position: relative;
  float: left;
  width: 100%;
  overflow: unset;
  margin: 0 auto; }
  .clamplines .clampline {
    float: left;
    width: 100%;
    height: auto;
    overflow: hidden; }
    .clamplines .clampline-1 {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 1; }
    .clamplines .clampline-2 {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 2; }
    .clamplines .clampline-3 {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 3; }
    .clamplines .clampline-4 {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 4; }
    .clamplines .clampline-5 {
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      /* autoprefixer: ignore next */
      -webkit-line-clamp: 5; }
  .clamplines.secret {
    position: absolute;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    padding: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); }
  .clamplines.carouselPost-title {
    height: 3em;
    line-height: 1.5em;
    text-align: center;
    margin-bottom: 15px; }
  .clamplines.carouselPost-desc {
    font-size: .8em;
    line-height: 1.5em;
    overflow: hidden; }
`